import queryString from 'query-string'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import CommonLayout from 'components/layout/common'
import ReferralLanding from 'components/referral/landing'
import BasePage from 'pages/base'
import Error from 'pages/_error'
import { PAGE_NAME } from 'pages/const'

class ReferralLandingPage extends BasePage {
  static getInitialProps({ store, req, res, isServer }) {
    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)
    }
    return {}
  }

  state = {
    ref_type: '',
  }

  getRefType = () => {
    const refTypeList = ['homefooter', 'me', 'loyalty']
    const urlParams = queryString.parse(window.location.search)

    if (refTypeList.includes(urlParams?.ref_type)) {
      this.setState({ ref_type: urlParams.ref_type })
    } else {
      this.setState({ ref_type: 'organic' })
    }
  }

  afterPageMount() {
    this.getRefType()
  }

  render() {
    if (!this.props.isCashbackEnable) {
      return <Error />
    }

    return (
      <CommonLayout
        noSidePadding
        noFooterTopMargin
        pageName={PAGE_NAME.referral}
      >
        <ReferralLanding ref_type={this.state.ref_type} />
      </CommonLayout>
    )
  }
}

ReferralLandingPage.propTypes = {
  internationalization: PropTypes.shape({
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  isCashbackEnable: PropTypes.bool.isRequired,
}

export default compose(
  connect((state) => ({
    internationalization: state.internationalization,
    isPhone: state.device.isPhone,
    isCashbackEnable: state.kcg.isCashbackEnable,
  })),
  withI18next(),
)(ReferralLandingPage)
